import { render, staticRenderFns } from "./cardCreateTodo.vue?vue&type=template&id=188e1abd"
import script from "./cardCreateTodo.vue?vue&type=script&lang=js"
export * from "./cardCreateTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports